// export const trucklistgroup = [
//   { _id: 0, name: "ทั้งหมด", classname: "btn btn-primary" },
//   { _id: 1, name: "รถบริษัท", classname: "btn btn-outline-dark" },
//   { _id: 2, name: "รถลูกค้า", classname: "btn btn-outline-dark" },
// ];
export const productgroup501=[ {_id:0, name: "กรุณาเลือก", classname :"btn btn-primary"  },{_id:2, name: "ไม้ท่อน" ,classname :"btn btn-outline-dark" },
{_id:10, name: "ไม้สับ" ,classname :"btn btn-outline-dark" }]
export const monthdata = [
  { _id: 0, name: "ทั้งหมด" },
  { _id: 1, name: "มกราคม" },
  { _id: 2, name: "กุมภาพันธ์" },
  { _id: 3, name: "มีนาคม" },
  { _id: 4, name: "เมษายน" },
  { _id: 5, name: "พฤษภาคม" },
  { _id: 6, name: "มิถุนายน" },
  { _id: 7, name: "กรกฎาคม" },
  { _id: 8, name: "สิงหาคม" },
  { _id: 9, name: "กันยายน" },
  { _id: 10, name: "ตุลาคม" },
  { _id: 11, name: "พฤศจิกายน" },
  { _id: 12, name: "ธันวาคม" },
];
